<template>
  <div
    v-if="$route.path !== '/login' && $route.path !== '/register' && $route.path !== '/verify'"
    class="fontts"
  >
    <v-layout wrap>
      <v-flex xs12 align-self-center text-center>
        <v-layout wrap>
          <v-flex xs12 sm12 md12 lg1 xl1 align-self-center text-left>
            <router-link
              class="routerlink"
              style="color: black"
              :to="{ name: 'Home' }"
            >
              <v-img
                :src="require('../assets/logos/FINAL LOGO KURMA (1).jpg')"
                contain
                height="90px"
              ></v-img>
            </router-link>
          </v-flex>
          <v-flex lg11 v-if="!appUser">
            <v-layout align-center class="hederbgcolor" wrap px-2>
              <v-flex xs12 sm8 md8 lg6 align-self-end text-left pb-6>
                <span class="titleLG">
                  KURMA – Tracking Indian Turtles and Tortoises
                </span>
              </v-flex>
              <v-flex
                xs12
                sm4
                md4
                lg3
                px-4
                pt-md-7
                pt-lg-6
                align-self-center
                text-right
              >
                <v-text-field
                  dense
                  rounded
                  light
                  :ripple="false"
                  placeholder="Search"
                  color="black"
                  background-color="#86AB5EF3"
                  append-icon="mdi-magnify"
                  height="45px"
                  style="width: 330px"
                  solo-inverted
                  v-model="searchData"
                  @change="search1"
                ></v-text-field>
              </v-flex>
               <v-flex xs2  sm1  class="hidden-md-and-up">
              <v-app-bar-nav-icon  style="color:white" @click="nav=true"></v-app-bar-nav-icon>
              <v-navigation-drawer height="450px"
              absolute
            
              v-model="nav">
                 <v-layout class="menufont1" wrap justify-center pa-3>
                            <v-flex xs12 align-self-center text-left>
                              <v-flex pa-2 pl-6>
                                <router-link
                                  class="routerlink"
                                  :to="{ name: 'Home' }"
                                >
                                  <span class="menufont1"
                                    >Home</span
                                  ></router-link
                                >
                              </v-flex>
                              
                              <v-flex py-4 pl-9 align-self-center text-center>
                                <div class="text-center">
                                  <v-menu offset-y>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-row
                                        color="#86ab5ef3"
                                        v-bind="attrs"
                                        v-on="on"
                                        elevation="0"
                                      >
                                        <span
                                          class="menufont1"
                                          style="text-align: center"
                                          >Identification</span
                                        >
                                      </v-row>
                                    </template>
                                    <v-list>
                                      <v-list-item
                                        v-for="(item, index) in dropdown"
                                        :key="index"
                                      >
                                        <v-list-item-title v-if="item.pos == 1">
                                          <div class="text-center">
                                            <v-menu offset-x>
                                              <template
                                                v-slot:activator="{ on, attrs }"
                                              >
                                                <v-btn
                                                  v-bind="attrs"
                                                  v-on="on"
                                                  :ripple="false"
                                                  plain
                                                  class="text-none"
                                                >
                                                  <span
                                                    style="
                                                      font-family: poppins-regular;
                                                    "
                                                    >{{ item.title }}</span
                                                  >
                                                </v-btn>
                                              </template>
                                              <v-list>
                                                <v-list-item
                                                  v-for="(item, index) in sub"
                                                  :key="index"
                                                >
                                                  <v-list-item-title>
                                                    <div class="text-center">
                                                      <router-link
                                                        class="routerlink"
                                                        :to="
                                                          (name =
                                                            item.path +
                                                            '/' +
                                                            item.type)
                                                        "
                                                      >
                                                        <span
                                                          style="
                                                            font-family: poppins-regular;
                                                            color: black;
                                                          "
                                                          >{{
                                                            item.subtitle
                                                          }}</span
                                                        ></router-link
                                                      >
                                                    </div>
                                                  </v-list-item-title>
                                                </v-list-item>
                                              </v-list>
                                            </v-menu>
                                          </div>
                                        </v-list-item-title>
                                        <v-list-item-title v-else>
                                          <div class="text-center">
                                            <router-link
                                              class="routerlink"
                                              :to="
                                                (name =
                                                  item.path + '/' + item.type)
                                              "
                                            >
                                              <v-btn
                                                class="text-none"
                                                plain
                                                :ripple="false"
                                              >
                                                <span
                                                  style="
                                                    font-family: poppins-regular;
                                                    color: black;
                                                  "
                                                  >{{ item.title }}</span
                                                >
                                              </v-btn></router-link
                                            >
                                          </div>
                                        </v-list-item-title>
                                      </v-list-item>
                                    </v-list>
                                  </v-menu>
                                </div>
                              </v-flex>
                              <v-flex pl-6 py-2>
                                <router-link
                                  class="routerlink"
                                  :to="{ name: 'rescuereport' }"
                                >
                                  <span class="menufont1"
                                    >Rescue</span
                                  ></router-link
                                >
                              </v-flex>
                              <v-flex pl-6 py-2>
                                <router-link
                                  class="routerlink"
                                  :to="{ name: 'observationreport' }"
                                >
                                  <span class="menufont1"
                                    >Observation</span
                                  ></router-link
                                >
                              </v-flex>
                              <v-flex pa-2 pl-6>
                                <router-link
                                  class="routerlink"
                                  :to="{ name: 'map' }"
                                >
                                  <span class="menufont1"
                                    >Assistance facilities</span
                                  ></router-link
                                >
                              </v-flex>
                              <v-flex pa-2 pl-6>
                                <router-link
                                  class="routerlink"
                                  :to="{ name: 'resources' }"
                                >
                                  <span class="menufont1"
                                    >Resources</span
                                  ></router-link
                                >
                              </v-flex>
                              <v-flex pa-2 pl-6>
                                <router-link
                                  class="routerlink"
                                  :to="{ name: 'Home' }"
                                >
                                  <span class="menufont1"
                                    >News</span
                                  ></router-link
                                >
                              </v-flex>
                              <v-flex pa-2 pl-6>
                                <router-link
                                  class="routerlink"
                                  :to="{ name: 'profile' }"
                                >
                                  <span class="menufont1"
                                    >My KURMA</span
                                  ></router-link
                                >
                              </v-flex>

                              
                            </v-flex>
                            <!-- <v-flex xs1 align-self-center>
                              <router-link
                                class="routerlink"
                                style="color: black"
                                :to="{ name: 'profile' }"
                              >
                                <v-icon color="green" size="35px"
                                  >mdi-heart</v-icon
                                >
                              </router-link>
                            </v-flex> -->
                            
                            <!-- <v-flex xs1 pt-3 align-self-center>
                              <v-icon size="35px" @click="logout" color="green"
                                >mdi-logout-variant</v-icon
                              >
                            </v-flex> -->
                          
                          </v-layout>
              </v-navigation-drawer>

              </v-flex>
              <v-flex xs6 sm9 md10 lg2 xl1 align-self-center text-right >
                <v-btn
                  large
                  :ripple="false"
      
                  text
                  style="color: white; background-color: #2f3b08f3"
                  @click="register"
                >
                  <span>Create Account</span>
                </v-btn>
              </v-flex>
              <v-flex px-4 xs4 sm1 md2 lg1 xl1 align-self-center text-right>
                <v-btn
                  :ripple="false"
                  text
                  large
                  style="color: white; background-color: #2f3b08f3"
                  @click="login"
                  ><span>Log In</span>
                </v-btn>
              </v-flex>
             

            </v-layout>
          </v-flex>

          <v-flex lg11 v-if="appUser">
            <v-layout align-center class="hederbgcolor" wrap px-2 pt-sm-3>
              <v-flex xs12 sm8 lg6 align-self-center text-left>
                <span class="titleLG">
                  KURMA – Tracking Indian Turtles and Tortoises
                </span>
              </v-flex>
              <v-layout>
                <v-flex>
                  <v-spacer></v-spacer>
                </v-flex>
              </v-layout>

              <v-flex
                xs10
                sm3
                md3
                lg3
                px-4
                pt-md-7
                pt-lg-6
                align-self-center
                text-right
              >
                <v-text-field
                  dense
                  rounded
                  light
                  :ripple="false"
                  placeholder="Search"
                  color="black"
                  background-color="#86AB5EF3"
                  append-icon="mdi-magnify"
                  height="45px"
                  style="width: 330px"
                  solo-inverted
                  v-model="searchData"
                  @change="search1"
                ></v-text-field>
              </v-flex>

              <v-flex lg1 sm1 xs1 pb-sm-5 pb-md-0 pb-lg-0 pb-6>
                <v-menu offset-y left max-width="300px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      v-bind="attrs"
                      dark
                      v-on="on"
                      color="white"
                      size="45px"
                      @click="menuon == true"
                      >mdi-account</v-icon
                    >
                  </template>
                  <v-card width="180px" class="hidden-sm-and-down">
                    <v-layout wrap justify-center text-center>
                      <v-flex xs12>
                        <v-list>
                          <v-layout class="menufont1" wrap justify-center pa-3>
                            <v-flex xs2 align-self-center>
                              <router-link
                                class="routerlink"
                                style="color: black"
                                :to="{ name: 'profile' }"
                              >
                                <v-icon color="green" size="35px"
                                  >mdi-account-details</v-icon
                                >
                              </router-link>
                            </v-flex>
                            <v-flex xs9 align-self-start>
                              <v-list-item>
                                <router-link
                                  class="routerlink"
                                  style="color: black"
                                  :to="{ name: 'profile' }"
                                >
                                  <v-list-item-title>
                                    {{ val1 }}
                                  </v-list-item-title>
                                </router-link>
                              </v-list-item>
                            </v-flex>
                            <v-flex xs12> </v-flex>
                            <v-flex xs1 pt-3 align-self-start>
                              <v-icon size="35px" @click="logout" color="green"
                                >mdi-logout-variant
                              </v-icon>
                            </v-flex>
                            <v-flex pl-3 xs10 align-self-start pr-6>
                              <v-list-item>
                                <v-list-item-title
                                  style="cursor: pointer"
                                  @click="logout"
                                >
                                  {{ val2 }}
                                </v-list-item-title>
                              </v-list-item>
                            </v-flex>
                          </v-layout>
                        </v-list>
                      </v-flex>
                      <v-flex py-12> </v-flex>
                    </v-layout>
                  </v-card>
                  <v-card width="300px" class="hidden-md-and-up">
                    <v-layout wrap justify-center text-center>
                      <v-flex xs12>
                        <v-list>
                          <v-layout class="menufont1" wrap justify-center pa-3>
                            <v-flex xs12 align-self-center text-left>
                              <v-flex pa-2 pl-6>
                                <router-link
                                  class="routerlink"
                                  :to="{ name: 'Home' }"
                                >
                                  <span class="menufont1"
                                    >Home</span
                                  ></router-link
                                >
                              </v-flex>
                              <v-flex py-4 pl-9 align-self-center text-center>
                                <div class="text-center">
                                  <v-menu offset-y>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-row
                                        color="#86ab5ef3"
                                        v-bind="attrs"
                                        v-on="on"
                                        elevation="0"
                                      >
                                        <span
                                          class="menufont1"
                                          style="text-align: center"
                                          >Identification</span
                                        >
                                      </v-row>
                                    </template>
                                    <v-list>
                                      <v-list-item
                                        v-for="(item, index) in dropdown"
                                        :key="index"
                                      >
                                        <v-list-item-title v-if="item.pos == 1">
                                          <div class="text-center">
                                            <v-menu offset-x>
                                              <template
                                                v-slot:activator="{ on, attrs }"
                                              >
                                                <v-btn
                                                  v-bind="attrs"
                                                  v-on="on"
                                                  :ripple="false"
                                                  plain
                                                  class="text-none"
                                                >
                                                  <span
                                                    style="
                                                      font-family: poppins-regular;
                                                    "
                                                    >{{ item.title }}</span
                                                  >
                                                </v-btn>
                                              </template>
                                              <v-list>
                                                <v-list-item
                                                  v-for="(item, index) in sub"
                                                  :key="index"
                                                >
                                                  <v-list-item-title>
                                                    <div class="text-center">
                                                      <router-link
                                                        class="routerlink"
                                                        :to="
                                                          (name =
                                                            item.path +
                                                            '/' +
                                                            item.type)
                                                        "
                                                      >
                                                        <span
                                                          style="
                                                            font-family: poppins-regular;
                                                            color: black;
                                                          "
                                                          >{{
                                                            item.subtitle
                                                          }}</span
                                                        ></router-link
                                                      >
                                                    </div>
                                                  </v-list-item-title>
                                                </v-list-item>
                                              </v-list>
                                            </v-menu>
                                          </div>
                                        </v-list-item-title>
                                        <v-list-item-title v-else>
                                          <div class="text-center">
                                            <router-link
                                              class="routerlink"
                                              :to="
                                                (name =
                                                  item.path + '/' + item.type)
                                              "
                                            >
                                              <v-btn
                                                class="text-none"
                                                plain
                                                :ripple="false"
                                              >
                                                <span
                                                  style="
                                                    font-family: poppins-regular;
                                                    color: black;
                                                  "
                                                  >{{ item.title }}</span
                                                >
                                              </v-btn></router-link
                                            >
                                          </div>
                                        </v-list-item-title>
                                      </v-list-item>
                                    </v-list>
                                  </v-menu>
                                </div>
                              </v-flex>
                              <v-flex pl-6 py-2>
                                <router-link
                                  class="routerlink"
                                  :to="{ name: 'rescuereport' }"
                                >
                                  <span class="menufont1"
                                    >Rescue</span
                                  ></router-link
                                >
                              </v-flex>
                              <v-flex pl-6 py-2>
                                <router-link
                                  class="routerlink"
                                  :to="{ name: 'observationreport' }"
                                >
                                  <span class="menufont1"
                                    >Observation</span
                                  ></router-link
                                >
                              </v-flex>
                              <v-flex pa-2 pl-6>
                                <router-link
                                  class="routerlink"
                                  :to="{ name: 'map' }"
                                >
                                  <span class="menufont1"
                                    >Assistance facilities</span
                                  ></router-link
                                >
                              </v-flex>
                              <v-flex pa-2 pl-6>
                                <router-link
                                  class="routerlink"
                                  :to="{ name: 'resources' }"
                                >
                                  <span class="menufont1"
                                    >Resources</span
                                  ></router-link
                                >
                              </v-flex>
                              <v-flex pa-2 pl-6>
                                <router-link
                                  class="routerlink"
                                  :to="{ name: 'Home' }"
                                >
                                  <span class="menufont1"
                                    >News</span
                                  ></router-link
                                >
                              </v-flex>
                              <v-flex pa-2 pl-6>
                                <router-link
                                  class="routerlink"
                                  :to="{ name: 'profile' }"
                                >
                                  <span class="menufont1"
                                    >My KURMA</span
                                  ></router-link
                                >
                              </v-flex>

                              <v-flex xs12>
                                <v-divider></v-divider>
                              </v-flex>
                            </v-flex>
                            
                            <v-flex xs12 align-self-center text-left>
                              <router-link
                                class="routerlink"
                                style="color: black"
                                :to="{ name: 'profile' }"
                              >
                                <v-list-item>
                                  <v-icon>mdi-account</v-icon>
                                  <v-list-item-title>
                                    {{ val1 }}
                                  </v-list-item-title>
                                </v-list-item>
                              </router-link>
                            </v-flex>
                            <v-flex xs12> </v-flex>
                           
                            <v-flex xs12 align-self-center text-left>
                              <v-list-item>
                                <v-icon>mdi-logout-variant</v-icon>
                                <v-list-item-title @click="logout">
                                  {{ val2 }}
                                </v-list-item-title>
                              </v-list-item>
                            </v-flex>
                          </v-layout>
                        </v-list>
                      </v-flex>
                      <v-flex py-12> </v-flex>
                    </v-layout>
                  </v-card>
                </v-menu>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import store from "../store";
// import axios from "axios";
export default {
  data: () => ({
    nav:false,
    drawer: false,
    group: null,
    menuon: false,
    val1: "My profile",
    val2: "Log out",
    searchData: "",
    keyword1: [],
    identification: "",
    dropdown: [
      {
        title: "Freshwater Turtles",
        pos: 1,
      },
      {
        title: "Sea Turtles",
        path: "/seaturtles",
        type: "Sea Turtles",
      },
      {
        title: " Invasive Species",
        path: "/seaturtles",
        type: "Invasive Species",
      },
      {
        title: "ID Key",
        path: "/glossary",
        type: "ID Key",
      },
    ],

    sub: [
      {
        subtitle: "Softshell",
        path: "/seaturtles",
        type: "Soft-Shell Turtle",
      },
      {
        subtitle: "Hardshell",
        path: "/seaturtles",
        type: "Hard-Shell Turtle",
      },
      {
        subtitle: "Tortoise",
        path: "/seaturtles",
        type: "Tortoise",
      },
    ],
  }),
  computed: {
    appUser() {
      return store.state.isLoggedIn;
    },
  },

  watch: {
    // searchData() {
    //   this.search1();
    // },
  },
  methods: {
    search1() {
      //  if (this.$route.query.searchkey == this.searchData) return;
          
       this.$router.push({
         path: "/Search",
         query:{
           searchkey :this.searchData,
         }
       })

       .then (() =>{this.$router.go()}

       );
      
       
    },
    login() {
      this.$router.push("login");
    },
    logout() {
      localStorage.removeItem("token");
      store.commit("loginUser", false);
      this.$router.push("/");
    },
    register() {
      this.$router.push("register");
    },
  },
};
</script>

<style>
.routerlink {
  text-decoration: none;
}
</style>